/**
 *
 * 会议基本信息(新增 & 编辑)
 *
 */
import Vue from 'vue';
import Component from "vue-class-component";

@Component
class eventEditor extends Vue {

    /**
     * model definition
     */
    isEditEvent = false;//web跟app逻辑公用

    isSHowHospital = false

    eventSizeModel = {
        "5W以下": "level1",
        "5W以上": "level2"
    }

    verifyForm = {
        applicant: false, //会议申请者
        organizer: false, //会议组织者
        name: false, //会议名称
        nature: false, //会议性质
        typeDictTxt: false, //会议类型
        city: false, //会议城市
        product: false, //产品
        diseaseArea: false, //疾病领域
        hospitalName: false, //医院名称
        hospitalDept: false, //科室
        eventSize: false,
        dtStart: false, //开始日期
        dtTypeTxt: false, //会议时段
        dtEnd: false, //结束日期,
        hasSpeaker: false, //
        speakerType: false, //
        qtyAttenderInt: false,
        qtyAttenderExt: false,
        isHospital: false, //
        address: false, //
    }

    eventForm = {
        applicant: "", //会议申请者
        organizer: "", //会议组织者
        tuUserId: "", //会议组织者id
        name: "", //会议名称
        cName: '', // PO操作人姓名
        accountName: '', // PO操作人员工号
        nature: "", //会议性质数值
        natureTxt: "", //会议性质文本值
        typeDictTxt: "", //会议类型
        product: "", //产品
        diseaseArea: "", //疾病领域
        hospitalName: "", //医院名称
        hospitalCode: "",//医院code
        hospitalId: "",//医院id
        hospitalDept: "", //科室
        hospitalEl: "", //医院坐标
        hospitalNl: "", //医院坐标
        provinceId: "", //地点信息
        cityId: "", //地点信息
        eventSize: "5W以下", //会议费用
        dtStart: "", //开始日期
        dtTypeTxt: "", //会议时段
        dtEnd: "", //结束日期
        city: "", //会议城市
        isHospital: "", //院内院外
        address: "", //会议地点
        qtyAttenderInt: "", //内部人数
        qtyAttenderExt: "", //外部人数
        hasSpeaker: "否", //是否有讲者
        speakerType: [], //是否有讲者
        descr: "", //备注
        isVMetting: false, // 是否网络会议 old
        vMettingType: 0, // 是否网络会议 new
        isUseAOne: "", // 是否使用A1视频会议
        vMettingUrl: "", // 网络会议参会人链接

    }

    isShowHasSpeaker = false //是否显示 是否有讲者
    hasRocheOnlineMeeting = false //是否有罗氏线上平台会议
    seapkerAuth = false //按当前登录用户获取 是否有讲者 显示权限
    verifyStatus = true //是否可以提交
    budgetAmount = 0 //计划会议预算
    isChange = true // ep第一次修改

    /**
     * dictionary definition
     */
    dict = {
        eventProperties: [], //会议性质
        productGroups: [], //产品 - 疾病领域 (filter by property)
        cities: [], //城市
        dtType: [] //会议时段
    }

    /**
     * TODO:变量命名不准,将逐步看齐dict
     */
    selectForm = {
        natureList: [], //会议性质
        typeList: [], //会议类型列表
        productList: [], //产品列表
        diseaseAreaList: [], //疾病领域
        eventSizeList: ["5W以下", "5W以上"], //疾病领域
        eventDateList: [], //会议时段
        cityList: [], //城市列表
        hasSpeakerList: ["是", "否"], //是否有讲者
        vMettingList: ["线下", "线上", "线上+线下"], //是否网络会议
        isHospitalList: [ '院外', '院内'], //是否网络会议
        speakerTypeList: [
            {
                label: '医生讲者',
                value: 1,
                isShow: '咨询委员会会议'
            },
            {
                label: '患者组织',
                value: 2
            },
            {
                label: '患者个人',
                value: 4
            }
        ]
    }

    get isEdit() {
        return JSON.parse(this.$route.query.isEditEvent || this.isEditEvent);
    }

    async created() {
        await this.loadUserInfo();
        await this.loadDictData();
        await this.getSeapkerAuth();
    }
    /**
     * 加载当前用户信息
     */
    async loadUserInfo() {
        var result = await this.api.post(this.url.identity.getme);
        let profileData = JSON.parse(result.content.profileData) || {};
        if (!result) return;
        {
            if (!this.isEdit) {
                if (!this.eventForm.tuUserId || !this.eventForm.organizer) {
                    this.eventForm.applicant = result.content.dspName; //会议申请者
                    this.eventForm.applyUserId = result.content.userId; //会议申请者id
                    this.eventForm.tuUserId = this.eventForm.applyUserId;
                    this.eventForm.organizer = this.eventForm.applicant;
                    this.eventForm.department = profileData.Duty || '';
                    this.eventForm.cName = result.content.dspName;
                    this.eventForm.accountName = result.content.userName;
                }
            }
            //编辑有自己的组织者,且有申请人
            if (this.isEdit) {
                this.eventForm.tuUserId = this.iStorage.get("editEventForm").tuUserId;
                this.eventForm.organizer = this.iStorage.get("editEventForm").amName;
                this.eventForm.applicant = this.iStorage.get("editEventForm").applyName; //会议申请者
                this.eventForm.applyUserId = this.iStorage.get("editEventForm").applyUserId; //会议申请者id
                this.eventForm.cName = this.iStorage.get("editEventForm").cName;
                this.eventForm.department = this.iStorage.get("editEventForm").itsExtData.department;
                this.eventForm.accountName = this.iStorage.get("editEventForm").accountName;
            }
            this.GetEventProperty()
            this.iStorage.set('tuUserId',this.eventForm.tuUserId)
        }
    }
    /**
     * 按当前登录用户获取 是否有讲者 显示权限
     */
    async getSeapkerAuth() {
        var response = await this.api.post(this.url.mice.hasSeapkerAuth, {userId: this.$store.state.newEventForm.tuUserId});
        if (response && response.success) {
            this.seapkerAuth = response.content.seapkerAuth;
            this.decideShow('isShowHasSpeaker')
        }
        ;
    }

    //获取会议性质
    async GetEventProperty(type = '') {
        var params = {
            userId: this.eventForm.tuUserId
        };
        var response = await this.api.post(this.url.mice.GetEventProperties, params);
        if (response && response.success) {
            this.selectForm.natureList = response.content;
            //根据部门来确认会议性质，如果只能获取一个就默认显示出来，如果能获取到两个就让办会人自己选择是推广还是非推广
            if (this.selectForm.natureList.length == 1) {
                this.eventForm.nature = this.selectForm.natureList[0].val;
                this.valueChange('nature')
            }
            //编辑会议,赋值之前需要先获取会议性质，需要遍历该数组
            let model = this.iStorage.get('model') || ''  // web端判断是否编辑
            let addType = model.addType || ''
            if ((this.isEdit || addType == 'edit') && type != 'noEdit') {
                this.editEvent();
            }
            if(this.eventForm.vMettingType == 1) {
                this.setRequired('address',false)
            }
            this.getTypeList()
        }
    }
    //获取会议类型
    getTypeList () {
        if (this.eventForm.nature && this.selectForm.natureList.length > 0) {
            this.selectForm.typeList = this.selectForm.natureList.filter(ele => {
                return ele.val == this.eventForm.nature;
            })[0].itsExtData.eventTypes;
            let params = {
                property:this.eventForm.nature,
                userId: this.eventForm.tuUserId,
                // isByProduct: false // 该参数仅在编辑会议时第一次默认调接口会传递，之后都不传递，暂认为该参数无效
            };
            this.QueryProductGroups(params); //获取产品
        }
    }
    //获取产品
    async QueryProductGroups(params) {
        let response = await this.api.post(this.url.mice.QueryProductGroups, params);
        if (response && response.success) {
            this.selectForm.diseaseAreaList = response.content;
            if (this.eventForm.diseaseArea) {
                this.selectForm.diseaseAreaList.map(ele => {
                    if (ele.diseaseName == this.eventForm.diseaseArea) {
                        this.selectForm.productList = ele.dieases;
                    }
                });
            }
        }
    }

    async loadDictData() {
        var response = await this.api.post(this.url.mice.OnLineCity);
        this.selectForm.cityList = this.dict.cities = response ? response.content : [];
        this.cityList = groupBy(this.selectForm.cityList);
        await this.queryDictionary({
            keyCode: "Proposal.DtType"
        }, 'eventDateList');
    }

    async queryDictionary(params, target) {
        var result = await this.api.post(this.url.dictionary.query, params)
        if (!result) return;
        {
            this.selectForm[target] = result.content;
            if (this.eventForm.isPlanMeeting) {
                this.eventForm.dtTypeTxt = this.selectForm.eventDateList.filter(ele => {
                    return ele.val == this.eventForm.dtTypeVal;
                })[0].txt
            }
        }
    }

    verifyParams() {
        this.verifyStatus = true;
        for (var key in this.verifyForm) {
            if (!this.eventForm[key] && ![0].includes(this.eventForm[key])) {
                this.verifyForm[key] = true;
            } else {
                this.verifyForm[key] = false;
            }
        }
        if( [0].includes(this.eventForm.vMettingType) || this.eventForm.vMettingType) {
            this.verifyForm.vMettingType = false;
        }
        if (!this.isShowHasSpeaker) {
            this.verifyForm.hasSpeaker = false;
        }
        if (!this.isShowHasSpeaker || this.eventForm.hasSpeaker === '否' || !['小组座谈','访谈','咨询','演讲','委员会','内部计划会',].includes(this.eventForm.typeDictTxt)) {
            this.verifyForm.speakerType = false;
        }
        if (!this.isSHowHospital) {
            this.verifyForm.hospitalName = false;
            this.verifyForm.hospitalDept = false;
        }
        if (this.eventForm.typeDictTxt == '院内会') {
            this.verifyForm.hospitalDept = false;
        }
        for (var key in this.verifyForm) {
            if (this.verifyForm[key]) {
                this.verifyStatus = false;
            }
        }
    }

    //编辑会议
    editEvent() {
        let editForm = this.iStorage.get("editEventForm");
        let disease = ['1', 1].includes(editForm.itsExtData.property) && editForm.itsExtData.therapeutic ? 'therapeutic' : 'disease'
        let natureData = this.selectForm.natureList.filter(ele => {
            return ele.val == editForm.itsExtData.property;
        })
        this.eventForm = {
            status: editForm.status,
            applicant: this.$store.state.newEventForm.applicant,
            organizer: this.eventForm.organizer, //会议组织者
            tuUserId: this.eventForm.tuUserId, //会议组织者id
            department: this.eventForm.department, //会议组织者id
            miceId: editForm.proposalId, //会议id
            name: decodeURIComponent(editForm.name), //会议名称
            nature: natureData.length ? editForm.itsExtData.property + '' : null, //会议性质
            natureTxt: natureData.length ? natureData[0].txt : null, //会议性质
            typeDictTxt: editForm.typeDictTxt, //会议类型
            dtStart: this.isEditEvent ? new Date(editForm.dtStart) : editForm.dtStart, //开始日期    elementUI日期控件reload时必须new一下,否则会出错
            dtEnd: this.isEditEvent ? new Date(editForm.dtEnd) : editForm.dtEnd, //结束日期
            dtTypeTxt: editForm.dtTypeTxt, //会议时段
            dtTypeVal: editForm.dtTypeVal, //会议时段
            city: editForm.cityDictTxt, //城市
            isHospital: ['0', 0].includes(editForm.itsExtData.isHospital) ? '院外' : ['1', 1].includes(editForm.itsExtData.isHospital) ? '院内' : '', //会议地点
            address: editForm.address, //会议地点
            qtyAttenderInt: editForm.qtyAttenderInt, //内部人数
            qtyAttenderExt: editForm.qtyAttenderExt, //外部人数
            diseaseArea: editForm.itsExtData[disease] ?
                editForm.itsExtData[disease].substring(editForm.itsExtData[disease].lastIndexOf("(") + 1, editForm.itsExtData[disease].length - 1) : "",
            product: editForm.itsExtData.product ? editForm.itsExtData.product.substring(editForm.itsExtData.product.lastIndexOf("(") + 1, editForm.itsExtData.product.length - 1) : "", //产品
            hospitalCode: editForm.itsExtData.hospitalCode,
            hospitalNl: editForm.itsExtData.hospitalNl,
            hospitalEl: editForm.itsExtData.hospitalEl,
            hospitalId: editForm.itsExtData.hospitalId || "",
            hospitalName: editForm.itsExtData.hospitalName,
            hospitalDept: editForm.itsExtData.hospitalDept,
            meetingCategory: editForm.itsExtData.meetingCategory, // 会议类别
            isEpMetting: editForm.itsExtData.isEpMetting, // 计划会议
            hasSpeaker: editForm.itsExtData.hasSpeaker ? "是" : "否",
            // isVMetting: editForm.itsExtData.isVMetting ? "线上" : "线下",
            vMettingType: ['0', '1', '2'].includes(editForm.itsExtData.vMettingType) ? Number(editForm.itsExtData.vMettingType) : editForm.itsExtData.vMettingType,
            isUseAOne: editForm.itsExtData.isUseAOne ? "是" : "否",
            vMettingUrl: editForm.itsExtData.vMettingUrl,
            descr: editForm.descr,
            GSDNumber: editForm.itsExtData.GSDNumber,
            eventSize: Object.keys(this.eventSizeModel)[Object.values(this.eventSizeModel).indexOf(editForm.itsExtData.eventSize) || 0],
            accountName: editForm.poAccountName,
            cName: editForm.pocName,
            speakerType: [],
            isPlanMeeting: editForm.itsExtData.isPlanMeeting,
            budgetAmount: `￥${Number(editForm.itsExtData.budgetAmount || 0).toFixed(2)}`
        };
        this.eventForm.provinceId = editForm.itsExtData.provinceId
        this.eventForm.cityId = editForm.itsExtData.cityId
        this.hasRocheOnlineMeeting = editForm.customData.hasRocheOnlineMeeting
        this.budgetAmount = `￥${Number(editForm.itsExtData.budgetAmount || 0).toFixed(2)}`;
        this.decideShow('isSHowHospital')
        this.decideShow('isShowHasSpeaker')
    }

    //获取部门，JSON.parse去掉最后一个逗号
    getDepartment() {
        let str = this.$store.state.personal.profileData;
        if (str && str.substr(-2, 1) == ',') {
            str = str.slice(0, -2) + str.slice(-1)
        }
        return str ? JSON.parse(str).Duty : '';
    }

    //保存会议
    async saveAsync({ onSuccess, toast, $messageError,}) {
        if (this.eventForm.status == 30) { // 添加需求阶段编辑是否是视频会议必填
            this.verifyForm.vMettingType = false
            if (!this.eventForm.vMettingType == 0) { // 是否使用A1视频会议必填
                this.verifyForm.isUseAOne = false
            }
        }
        if (this.eventForm.vMettingType == 0) {
            this.eventForm.isUseAOne = ''
        }
        // 线上会议，会议地点非必填
        if (this.eventForm.vMettingType == 1) {
            delete this.verifyForm.address
        }
        if (this.eventForm.isUseAOne == '是') {
            this.eventForm.vMettingUrl = ''
        }
        if (this.eventForm.eventSize == '5W以上') {
            this.verifyForm.accountName = false
        } else {
            delete this.verifyForm.accountName
        }
        this.verifyParams();
        if (!this.verifyStatus) {
            if (toast) {
                toast('必填项不能为空')
            }
            if ($messageError) {
                $messageError('必填项不能为空')
            }
            this.canSave = true;
            return false;
        }
        let speaker = 0
        this.eventForm.speakerType.forEach(item => {
            speaker = speaker | item
        })
        var editForm = this.iStorage.get("editEventForm");
        var params = {
            miceId: this.eventForm.miceId ? this.eventForm.miceId : "", //这个是proposalId，编辑的时候会用到，会从列表给过来
            applyUserId: this.$store.state.newEventForm.applyUserId, //会议申请者
            tuUserId: this.$store.state.newEventForm.tuUserId, //会议组织者
            name: this.eventForm.name, //会议名称
            typeDictTxt: this.eventForm.typeDictTxt, //会议类型
            dtStart: this.formatDate(this.eventForm.dtStart), //开始日期
            dtEnd: this.formatDate(this.eventForm.dtEnd), //结束日期
            dtTypeVal: this.eventForm.dtTypeTxt ?
                this.selectForm.eventDateList.filter(ele => {
                    return ele.txt == this.eventForm.dtTypeTxt;
                })[0].val : "", //会议时段
            dtTypeTxt: this.eventForm.dtTypeTxt, //会议时段
            country: "中国",
            province: this.selectForm.cityList.filter((ele) => {
                return ele.txt == this.eventForm.city
            })[0].province, // 省份
            city: this.eventForm.city, //城市
            address: this.eventForm.address, //会议地点
            qtyAttenderInt: this.eventForm.qtyAttenderInt, //内部人数
            qtyAttenderExt: this.eventForm.qtyAttenderExt, //外部人数
            itsExtData: {
                provinceId: this.eventForm.provinceId, // 选择城市信息
                cityId: this.eventForm.cityId, // 选择城市信息
                department: this.$store.state.newEventForm.department,
                property: this.eventForm.nature,//会议性质
                isHospital: ['院内'].includes(this.eventForm.isHospital) ? 1 : ['院外'].includes(this.eventForm.isHospital) ? 0 : '',//会议性质
                product: this.eventForm.product && this.selectForm.productList.filter(ele => {
                    return ele.brandName == this.eventForm.product;
                }).length > 0 ?
                    this.selectForm.productList.filter(ele => {
                        return ele.brandName == this.eventForm.product;
                    })[0].brandEName +
                    "(" +
                    this.eventForm.product +
                    ")" : "", //产品
                hospitalCode: this.$store.state.newEventForm.hospitalCode, //医院code
                hospitalId: this.$store.state.newEventForm.hospitalId, //医院id
                hospitalEl: this.$store.state.newEventForm.hospitalEl || this.eventForm.hospitalEl, //医院经度
                hospitalNl: this.$store.state.newEventForm.hospitalNl || this.eventForm.hospitalNl, //医院纬度
                hospitalName: this.$store.state.newEventForm.hospitalName, //医院名称
                hospitalDept: this.$store.state.newEventForm.hospitalDept, //科室
                hasSpeaker: this.isShowHasSpeaker ? ["是"].includes(this.eventForm.hasSpeaker) ? true : false : false, //是否有讲者
                isVMetting: (this.eventForm.vMettingType == '线下' || this.eventForm.vMettingType == 0) ? false : true,//是否网络会议
                vMettingType: typeof(this.eventForm.vMettingType) == "string" ? this.selectForm.vMettingList.indexOf(this.eventForm.vMettingType) : this.eventForm.vMettingType,
                isUseAOne: ((this.eventForm.isUseAOne == '是' || this.eventForm.isUseAOne == 0)) && this.eventForm.isUseAOne != '' ? true : (this.eventForm.isUseAOne == '否' || this.eventForm.isUseAOne == 1) ? false : '',//是否使用A1视频会议
                vMettingUrl: this.eventForm.vMettingUrl, //网络会议参会人链接
                speakerType: speaker,
                GSDNumber: this.$store.state.newEventForm.GSDNumber,
                eventSize: this.eventSizeModel[this.eventForm.eventSize],
                poAccountName: this.$store.state.newEventForm.accountName,

            },
            descr: this.eventForm.descr //备注
        };
        let disease = ['推广', '1'].includes(this.eventForm.nature) ? 'therapeutic' : 'disease'
        params.itsExtData[disease] = this.eventForm.diseaseArea && this.selectForm.diseaseAreaList.filter(ele => {
            return ele.diseaseName == this.eventForm.diseaseArea;
        }).length > 0 ?
            this.selectForm.diseaseAreaList.filter(ele => {
                return ele.diseaseName == this.eventForm.diseaseArea;
            })[0].diseaseEName +
            "(" +
            this.eventForm.diseaseArea +
            ")" : ""
        let meetingInfo = this.iStorage.get("editEventForm");
        if (meetingInfo) {
            let oldMeetKeys = Object.keys(meetingInfo.itsExtData)
            let keys = [...oldMeetKeys]
            keys.forEach(ele => {
                if (!(ele in params.itsExtData)) {
                    params.itsExtData[ele] = meetingInfo.itsExtData[ele]
                }
            })
        }
        let funName = 'SaveEvent'
        if (this.eventForm.status == 30) {
            funName = 'EditMiceInfo'
            params = {
                ProposalId: this.eventForm.miceId,
                IsVMetting: (this.eventForm.vMettingType == '线下' || this.eventForm.vMettingType == 0) ? false : true,//是否网络会议
                VMettingType: typeof(this.eventForm.vMettingType) == "string" ? this.selectForm.vMettingList.indexOf(this.eventForm.vMettingType) : this.eventForm.vMettingType,
                IsUseAOne: (this.eventForm.isUseAOne == '是' || this.eventForm.isUseAOne == 0) ? true : (this.eventForm.isUseAOne == '否' || this.eventForm.isUseAOne == 1) ? false : '',//是否使用A1视频会议
                VMettingUrl: this.eventForm.vMettingUrl, //网络会议参会人链接
                PoAccountName: this.$store.state.newEventForm.accountName,
                GSDNumber: this.eventForm.GSDNumber, //GSD号码
                Descr: this.eventForm.descr, //备注
            }
        }
        this.api.post(this.url.mice[funName], params).then(response => {
            this.canSave = true;
            this.btnLoading = false;
            if (response && response.success) {
                onSuccess(response);
                if(editForm.itsExtData.eventSize != params.itsExtData.eventSize) {
                    this.deleteBudgetItem()
                }
            }
        });

    }

    // 批量删除预算项目
    async deleteBudgetItem() {
        let budgetIds = JSON.parse(sessionStorage.getItem("budgetItemList")).map(item => {
            return item.budgetId
        })
        let params = {
            miceId: this.eventForm.miceId,
            budgetIds: budgetIds
        };
        let res = await this.api.post(this.url.budget.deleteAll, params);
        if(res && res.success) {
            sessionStorage.removeItem("budgetItemList")
        }
    }
    async validateAsync() {

    }
}

export default eventEditor;


//分组
export const groupBy = (list) => {
    const groups = {};
    list.forEach(function (o) {
        const group = o.province;
        groups[group] = groups[group] || [];
        groups[group].push(o.txt);
    });
    // return Object.keys(groups).map(function (group) {
    //     return groups[group];
    // });
    return groups;
}



// WEBPACK FOOTER //
// ../scripts/components/eventEditor.js